import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable } from "rxjs";

import { ConfigService } from "./config.service";
import { HeaderFactoryService } from "./header-factory.service";

@Injectable()
export class LogoutService {


  constructor(private httpsClient: HttpClient, private headerService: HeaderFactoryService, private configService: ConfigService) { }

  logout(email: string, forceCacheClear: boolean): Observable<any> {

    return this.httpsClient.post(`${this.configService.apiUrl}api/v${this.configService.apiVersion}/profile/logout/${email}/${forceCacheClear}`,
      null,
      this.headerService.getAuthorizationHeaderOptions()
    );
  }
}
 